/*
  Lightbox for the "Fresh - Social media" Instagram carousel.
  Progressive enhancement: without JS the slides stay plain links to the Instagram post.
  Swiper clones slides when loop is on, so items are collected by data-of-lb-index.
*/
(function () {
  if (window.ofSocialLightbox) return;

  var overlay = null;
  var els = {};
  var items = [];
  var current = 0;
  var lastFocus = null;
  var labels = {};

  function readLabels(section) {
    return {
      dialog: section.getAttribute('data-of-lb-label') || 'Instagram',
      close: section.getAttribute('data-of-lb-close') || 'Close',
      prev: section.getAttribute('data-of-lb-prev') || 'Previous',
      next: section.getAttribute('data-of-lb-next') || 'Next',
      link: section.getAttribute('data-of-lb-link') || 'Instagram'
    };
  }

  function collect(section) {
    var seen = {};
    var list = [];
    var nodes = section.querySelectorAll('[data-of-lb-index]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var key = el.getAttribute('data-of-lb-index');
      if (seen[key]) continue;
      seen[key] = true;
      list.push({
        index: parseInt(key, 10),
        src: el.getAttribute('data-of-lb-src') || '',
        alt: el.getAttribute('data-of-lb-alt') || '',
        caption: el.getAttribute('data-of-lb-caption') || '',
        href: el.getAttribute('data-of-lb-href') || '',
        type: el.getAttribute('data-of-lb-type') || 'IMAGE'
      });
    }
    return list.sort(function (a, b) {
      return a.index - b.index;
    });
  }

  function icon(path) {
    return (
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      path +
      '</svg>'
    );
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'of-lb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', labels.dialog);
    overlay.innerHTML =
      '<div class="of-lb__stage">' +
      '<div class="of-lb__dialog">' +
      '<button type="button" class="of-lb__btn of-lb__close" data-of-lb-action="close">' +
      icon('<path d="M18 6 6 18M6 6l12 12"/>') +
      '</button>' +
      '<div class="of-lb__media"><img alt="" /></div>' +
      '<div class="of-lb__body">' +
      '<p class="of-lb__caption"></p>' +
      '<a class="of-lb__link" target="_blank" rel="noopener"></a>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="of-lb__btn of-lb__prev" data-of-lb-action="prev">' +
      icon('<path d="M15 18l-6-6 6-6"/>') +
      '</button>' +
      '<button type="button" class="of-lb__btn of-lb__next" data-of-lb-action="next">' +
      icon('<path d="M9 6l6 6-6 6"/>') +
      '</button>' +
      '</div>';

    els.dialog = overlay.querySelector('.of-lb__stage');
    els.img = overlay.querySelector('.of-lb__media img');
    els.caption = overlay.querySelector('.of-lb__caption');
    els.link = overlay.querySelector('.of-lb__link');
    els.close = overlay.querySelector('.of-lb__close');
    els.prev = overlay.querySelector('.of-lb__prev');
    els.next = overlay.querySelector('.of-lb__next');

    els.close.setAttribute('aria-label', labels.close);
    els.prev.setAttribute('aria-label', labels.prev);
    els.next.setAttribute('aria-label', labels.next);

    overlay.addEventListener('click', function (event) {
      var action = event.target.closest ? event.target.closest('[data-of-lb-action]') : null;
      if (action) {
        event.preventDefault();
        var name = action.getAttribute('data-of-lb-action');
        if (name === 'close') close();
        if (name === 'prev') step(-1);
        if (name === 'next') step(1);
        return;
      }
      if (!els.dialog.contains(event.target)) close();
    });

    var startX = null;
    overlay.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
      },
      { passive: true }
    );
    overlay.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) return;
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 45) step(delta < 0 ? 1 : -1);
        startX = null;
      },
      { passive: true }
    );

    document.body.appendChild(overlay);
  }

  function render() {
    var item = items[current];
    if (!item) return;
    els.img.setAttribute('src', item.src);
    els.img.setAttribute('alt', item.alt);
    els.caption.textContent = item.caption;
    els.caption.hidden = item.caption === '';
    if (item.href) {
      els.link.setAttribute('href', item.href);
      els.link.textContent = labels.link;
      els.link.hidden = false;
    } else {
      els.link.hidden = true;
    }
    var many = items.length > 1;
    els.prev.hidden = !many;
    els.next.hidden = !many;
  }

  function step(direction) {
    if (!items.length) return;
    current = (current + direction + items.length) % items.length;
    render();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  }

  function open(section, index) {
    labels = readLabels(section);
    items = collect(section);
    if (!items.length) return;

    var position = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].index === index) position = i;
    }
    current = position;

    if (!overlay) build();
    overlay.setAttribute('aria-label', labels.dialog);
    render();

    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    els.close.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-of-lb-index]') : null;
    if (!trigger) return;
    var section = trigger.closest('.social-medias');
    if (!section) return;
    event.preventDefault();
    open(section, parseInt(trigger.getAttribute('data-of-lb-index'), 10));
  });

  window.ofSocialLightbox = { open: open, close: close };
})();
